export default __webpack_public_path__ + "static/media/proj1.07398ea4.png";